export default {"src":"/_next/static/media/selected-icon.6a9e9651.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};